export function route(pageContext: Vike.PageContext) {
  const numberOnly = pageContext.urlPathname.match(/\/order\/([0-9]+)$/);

  if (numberOnly) {
    const [, productId] = numberOnly;

    return { routeParams: { productId } };
  }

  const knownSports = pageContext.urlPathname.match(
    /\/order\/(ras|cfb|cbb|nfl|wnba|nba|ufl|cbase|cfl|bt)(?:\/([0-9]+))?$/,
  );

  if (knownSports) {
    const [, sportId, productId] = knownSports;

    return { routeParams: { sportId, productId: productId || '' } };
  }

  if (pageContext.urlPathname === '/order/betting-talk') {
    return { routeParams: { productId: '49' } };
  }

  if (pageContext.urlPathname === '/order/plus') {
    return { routeParams: { productId: '56' } };
  }

  const textAlso = pageContext.urlPathname.match(/\/order\/([a-zA-Z0-9_-]+)$/);

  if (textAlso) {
    const [, tag] = textAlso;

    return { routeParams: { tag } };
  }

  return false;
}
